import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/app/series/$seriesId')({
  component: lazyRouteComponent(() => import('./-$seriesId')),
})
